import Image from "next/image";
import React from "react";

export default function RegisterMemberInfo() {
  return (
    <div className="mx-auto mt-10 space-y-8 mb-10">
      <hr className="bg-[#126d37] h-1" />
      <section>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          สิทธิพิเศษ สมัครนายหน้าประกันรถยนต์ ประกันภัยทุกชนิด
        </h2>
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li>
            ขายประกันภัยได้ทุกประเภท มากกว่า 30 บริษัท ไม่ต้องวางเงินค้ำประกัน
          </li>
          <li>รับสิทธิในการเข้าอบรมความรู้ด้านประกันภัย ทุกสาขาทั่วประเทศ</li>
          <li>รับฟรี สิทธิในการสอนงานด้วยระบบออนไลน์</li>
          <li>รับฟรี เว็บไซต์สำหรับขยายทีมสมาชิก</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          วิธีการสมัครสมาชิกศรีกรุงโบรคเกอร์ เตรียมเอกสารดังนี้
        </h2>
        <ol className="list-decimal list-inside space-y-4 text-gray-700">
          <li>
            สำเนาบัตรประชาชน รับรองสำเนา{" "}
            <strong>“ใช้สมัครสมาชิกศรีกรุงโบรคเกอร์”</strong>
          </li>
          <li>
            ค่าสมัครสมาชิก
            <ul className="list-disc list-inside ml-5 mt-2 space-y-2">
              <li>
                <strong>อายุ 20-60 ปี:</strong> ค่าสมัคร 200 บาท รับฟรี
                ประกันอุบัติเหตุทุน 1 แสนบาท ไม่มีค่ารักษา คุ้มครอง 1 ปี
              </li>
              {/* <li>
                <strong>อายุ 17-19 ปี และ 61-90 ปี:</strong> ค่าสมัคร 250 บาท
                รับฟรีประกันอุบัติเหตุทุน 2 แสนบาท ไม่มีค่ารักษา คุ้มครอง 1 ปี
              </li> */}
            </ul>
          </li>
          <li>สำเนาหน้าบัญชี ของธนาคารกสิกร หรือใช้ของธนาคารอื่นๆ (ถ้ามี)</li>
          <li>สำเนาบัตรนายหน้าประกันวินาศภัย ที่ยังไม่หมดอายุ (ถ้ามี)</li>
        </ol>
        <p className="mt-4 text-gray-700">
          <strong>***</strong> กรอกใบสมัครที่ฟอร์มนี้ หรือ ติดต่อเราผ่านไลน์{" "}
          <strong>***</strong>
        </p>
        <div className="flex md:flex-row flex-col gap-5 mt-5 mb-5">
          <Image
            src="/image/reg-member-info-1.png"
            width={500}
            height={500}
            alt="reg-member-info-1"
          />
          <Image
            src="/image/reg-member-info-2.png"
            width={500}
            height={500}
            alt="reg-member-info-2"
          />
        </div>
      </section>
      <hr className="bg-[#126d37] h-1" />
    </div>
  );
}
